
import {Button as Base} from './_Button';
import {Link} from './_Link';

export default Object.assign(Base, {
	Link,
});
